import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-stop",
  "use": "foquz-icon-stop-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" id=\"foquz-icon-stop\"><path d=\"M17 9A7.999 7.999 0 111.002 9 7.999 7.999 0 0117 9h0z\" stroke=\"#F96261\" stroke-width=\"2\" stroke-linecap=\"round\" /><path stroke=\"#F96261\" stroke-width=\"2\" d=\"M6 6h6v6H6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol